export const environment = {
  version: '3.3.1.33',
  version_web: '3.3.1.33',
  production: true,
  api: '/api'
};

